<template>
  <v-otp-input
    v-bind="$attrs"
    density="compact"
    variant="outlined"
    :class="{
      'success-field': success,
      'error-field': errorMessages.length
    }"
    :base-color="success ? 'success' : 'basic'"
    :error-messages="errorMessages"
  />
</template>

<script setup>
defineProps({
  success: Boolean,
  errorMessages: { type: Array, default: () => [] }
});
</script>
